export default "__VITE_ASSET__CSuaumzF__"